import React, { FC, memo } from 'react'

import { useSelector } from 'react-redux'

import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'

import { eventsSearchSelectors } from '@ucheba/store/events/search'

import { p11n } from '@ucheba/utils/helpers/string'
import { Divider } from '@ucheba/ui/components/Divider/desktop'
import { Banner } from '../../../../../../components/Banner/desktop'
import LayoutInstitution from '../../../../../../components/LayoutInstitution/desktop'
import EventsList from '../../../../../../components/EventsList/desktop/EventsList'
import EmptyListPlaceholder from '../../../../components/EmptyListPlaceholder'
import { useBannerProgramTypes } from '../../utils/useBannerProgramTypes'
import { isPaidPackage } from '../../utils/isPaidPackage'
import Pagination from '../../../../components/Pagination/desktop'

const InstitutionEventsPage: FC = () => {
  const events = useSelector(eventsSearchSelectors.entity)

  const { extraParams, paidPackage } = useBannerProgramTypes()

  return (
    <>
      <LayoutInstitution>
        <Heading as='h1' h2='Дни открытых дверей' spacing='small' />

        <Spacing spacing='large' />

        {!events?.total ? (
          <EmptyListPlaceholder
            title='В ближайшее время мероприятий для абитуриентов не планируется.'
            linkText='Посмотреть Дни открытых дверей в других вузах'
            link='/for-abiturients/events'
          />
        ) : (
          <>
            <EventsList
              isBanner={!isPaidPackage(paidPackage)}
              params={extraParams}
              items={events?.items}
              href='/for-abiturients/events'
            />

            {events?.total > 15 && (
              <>
                <Divider />

                <Pagination
                  showItemsCount={15}
                  totalCount={`${events?.total} ${p11n(
                    events?.total || 0,
                    'мероприятие',
                    'мероприятия',
                    'мероприятий'
                  )}`}
                  total={events?.total}
                />
              </>
            )}
          </>
        )}

        <Spacing spacing='uxxlarge' />
      </LayoutInstitution>

      {!isPaidPackage(paidPackage) && <Banner id={6} extraParams={extraParams} />}
    </>
  )
}

export default memo(InstitutionEventsPage)
